/* eslint-disable import/no-default-export */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (val: any, message = 'assertion failed') => {
  if (!val) {
    throw new Error(message);
  }
};



// WEBPACK FOOTER //
// ./app/gamma/src/util/assert.ts